// src/components/Spinner.js
import React from "react";
import "./Spinner.css"; // Import the same spinner CSS

const Spinner = () => {
  return (
    <div className="spinner">
      <div></div>
    </div>
  );
};

export default Spinner;
